/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Reaction_HeartInputs */

const en_us2_clubs_reaction_heart = /** @type {(inputs: Clubs_Reaction_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heart`)
};

const pt_br2_clubs_reaction_heart = /** @type {(inputs: Clubs_Reaction_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coração`)
};

const es_419_clubs_reaction_heart = /** @type {(inputs: Clubs_Reaction_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corazón`)
};

const pt_pt2_clubs_reaction_heart = /** @type {(inputs: Clubs_Reaction_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coração`)
};

const fr_fr2_clubs_reaction_heart = /** @type {(inputs: Clubs_Reaction_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cœur`)
};

const de_de2_clubs_reaction_heart = /** @type {(inputs: Clubs_Reaction_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herz`)
};

const it_it2_clubs_reaction_heart = /** @type {(inputs: Clubs_Reaction_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuore`)
};

/**
* | output |
* | --- |
* | "Heart" |
*
* @param {Clubs_Reaction_HeartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_reaction_heart = /** @type {((inputs?: Clubs_Reaction_HeartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Reaction_HeartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_reaction_heart(inputs)
	if (locale === "es-419") return es_419_clubs_reaction_heart(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_reaction_heart(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_reaction_heart(inputs)
	if (locale === "de-DE") return de_de2_clubs_reaction_heart(inputs)
	if (locale === "it-IT") return it_it2_clubs_reaction_heart(inputs)
	return en_us2_clubs_reaction_heart(inputs)
});
export { clubs_reaction_heart as "clubs.reaction_heart" }